const products = "/products";
const monitor = "/monitor";
const settings = "/settings";
const companies = "/companies";
const companiesData = `${companies}/:companyId`;
const companiesConnections = `${companies}/:companyId/connections`;
const developers = "/developers";
const webhooks = `${settings}/webhooks`;
export const integrations = `${settings}/integrations`;
const spendInsights = "/spend-insights";

export const paths = {
  HOME: "/",
  ONBOARDING: "/onboarding",
  COMPANIES: "/companies",
  COMPANIES_DATA: companiesData,
  companies: {
    CONNECTIONS: companiesConnections,
    SUMMARY: `${companiesData}/summary`,
    FILES: `${companiesData}/files`,
    SETTINGS: `${companiesData}/settings`,
    ASSESS: `${companiesData}/assess`,
    DATASETS: `${companiesData}/datasets`,
    ACCOUNTING_API: `${companiesData}/accounting-api`,
    BANKING_API: `${companiesData}/banking-api`,
    COMMERCE_API: `${companiesData}/commerce-api`,
    ACCOUNTING_DATA: `${companiesData}/accounting`,
    BANKING_DATA: `${companiesData}/banking`,
    COMMERCE_DATA: `${companiesData}/commerce`,
    READ_HISTORY: `${companiesData}/pull-history`,
    WRITE_HISTORY: `${companiesData}/push-history`,
    ACCOUNTS_SUMMARY: `${companiesData}/accounts/summary`,
  },
  products: {
    SYNC_FOR_COMMERCE: `${products}/sync-for-commerce`,
    SYNC_FOR_EXPENSES: `${products}/sync-for-expenses`,
    SYNC_FOR_BANKING: `${products}/sync-for-banking`,
    ACCOUNTING_API: `${products}/accounting-api`,
    BANKING_API: `${products}/banking-api`,
    COMMERCE_API: `${products}/commerce-api`,
    SPEND_INSIGHTS: `${products}/spend-insights`,
    NESTED_ROUTES: {
      DEVELOPER_RESOURCES: "/developer-resources",
      PRODUCT_OVERVIEW: "/product-overview",
      API_COVERAGE: "/api-coverage",
    },
  },
  SPEND_INSIGHTS: spendInsights,
  spendInsights: {
    company: {
      INSIGHTS: `${spendInsights}/companies/:companyId/insights`,
      THREADS: `${spendInsights}/companies/:companyId/insights/threads`,
      THREAD: `${spendInsights}/companies/:companyId/insights/threads/:threadId`,
    },
  },
  monitor: {
    EVENTS: `${monitor}/events`,
    ALERTS: `${monitor}/alerts`,
    ALERT_SETTINGS: `${monitor}/alert-settings`,
    CONNECTOR_HEALTH: `${monitor}/connector-health`,
    MANAGED_BANK_FEEDS_SYNCS: `${monitor}/managed-bank-feeds/syncs`,
    RULES_OLD: `${monitor}/rules`,
    WEBHOOK_SETTINGS_OLD: `${monitor}/webhook-settings`,
  },
  settings: {
    OVERVIEW: settings,
    LINK_SETTINGS: `${settings}/link-settings`,
    BRANDING: `${settings}/branding`,
    REDIRECTS: `${settings}/redirects`,
    INTEGRATIONS_ACCOUNTING: `${integrations}/accounting`,
    INTEGRATIONS_BANKING: `${integrations}/banking`,
    INTEGRATIONS_MANAGE_SOURCES: `${integrations}/banking/manage/truelayer/sources`,
    INTEGRATIONS_COMMERCE: `${integrations}/commerce`,
    INTEGRATIONS_OTHER: `${integrations}/other`,
    INTEGRATIONS_BANK_FEEDS: `${integrations}/bankfeeds`,
    DATA_TYPES: `${settings}/data-types`,
    USERS: `${settings}/users`,
    PRODUCTS: `${settings}/products`,
    PRODUCT_SETTINGS: `${settings}/products/:productKey`,
    MANAGE_PRODUCTS: `${settings}/manage-products`,
    BILLING: `${settings}/billing`,
    USAGE: `${settings}/billing/usage`,
    RULES: `${webhooks}/rules`,
    WEBHOOK_SECURITY: `${webhooks}/security`,
  },
  account: {
    SETTINGS: `${settings}/account`,
  },
  developers: {
    API_KEYS: `${developers}/api-keys`,
    DEPRECATIONS: `${developers}/api-deprecations`,
  },
  clients: {
    SELECT: "/select",
  },
  auth: {
    SSO_SIGN_IN: "/sso/signin/:connection?",
    INVITE_ACCEPT: "/invite/:invitationId/accept",
  },
};
